import React, { useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { PageTitle, HostResume, Loader } from '../../../../components';
import { loadHosts } from '../../../../redux';
import { Row, Col, Button } from 'reactstrap';
import Icon from '@mdi/react';
import { mdiArrowLeftCircle } from '@mdi/js';

const HostsList = () => {
    const { t }    = useTranslation();
    const dispatch = useDispatch();

    const { connected }  = useSelector(state => state.sioBridge);
    const { hosts } = useSelector(state => state.hosts, shallowEqual);
    const { isLoading }  = useSelector(state => state.hosts);

    useEffect(() => {
        if (connected)
            dispatch(loadHosts());
    }, [dispatch, connected]);

    const actions = <Link to="/devices">
        <Button color="info">
            <Icon path={ mdiArrowLeftCircle } size={ 1 } color="white" /> { t('common.back') }
        </Button>
    </Link>;

    return (
        <div className="HostsList">
            <PageTitle
                title={ t('hosts.title') }
                icon="cube"
                actions={ actions }
            />

            {isLoading && (
                <Loader />
            )}

            {!isLoading && (
            <div className="mt-3">
                <Row>
                { hosts && hosts.filter(p => p.isConnected()).map(host => (
                    <Col key={ host.id } lg={ 2 } md={ 4 } sm={ 6 } xs={ 12 }>
                        <HostResume host={ host } className="mb-3" />
                    </Col>
                ))}
                { hosts && hosts.filter(p => !p.isConnected()).map(host => (
                    <Col key={ host.id } lg={ 2 } md={ 4 } sm={ 6 } xs={ 12 }>
                        <HostResume host={ host } className="mb-3" />
                    </Col>
                ))}
                </Row>
            </div>
            )}
        </div>
    );
}

export default HostsList;
